var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import DropdownButton from "../../Button/Dropdown/DropdownButton";
var BatchActions = function (_a) {
    var batchActions = _a.batchActions, data = _a.data, setData = _a.setData, dropdownButtonText = _a.dropdownButtonText, _b = _a.alwaysShowToolbar, alwaysShowToolbar = _b === void 0 ? false : _b;
    var selectedItems = useMemo(function () {
        return data.content.filter(function (d) { return d._selected; }) || [];
    }, [data]);
    var deselectAll = function () {
        var newContent = data.content.map(function (d) { return (__assign(__assign({}, d), { _selected: false })); });
        setData(__assign(__assign({}, data), { content: newContent }));
    };
    if (selectedItems.length === 0 && !alwaysShowToolbar) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(DropdownButton, { text: dropdownButtonText(selectedItems.length), style: "white", disabled: selectedItems.length === 0, alignRight: false, actions: batchActions.map(function (actions) { return (actions.map(function (action) { return ({
            type: action.type || "default",
            text: action.text,
            icon: action.icon,
            onClick: function () { return action.onClick(selectedItems, deselectAll); },
            disabled: action.disabled || false
        }); })); }) }));
};
export default BatchActions;
